import { CmsValue } from 'core/type/BootstrapConfig.types';
import { DurationType } from 'gql/autogen/DurationType';
import roundUpDuration from 'core/utils/roundUpDuration';
import { DurationInfo } from 'gql/autogen/DurationInfo';

const isDurationRangeInvalid = (from: number, until: number): boolean => {
    return until - from >= from;
};

const getDurationText = (duration: DurationInfo, cms: CmsValue): string => {
    const minute = duration.minutes || 0;
    const type = duration.durationType || DurationType.UNKNOWN;
    const minuteUntil = duration.minutesUntil || 0;
    if (minute <= 0 || type === DurationType.FLEXIBLE || type === DurationType.UNKNOWN) {
        if (type === DurationType.FLEXIBLE) {
            return cms[128059];
        }
        return '';
    }

    if (type === DurationType.FIXED && minuteUntil > 0) {
        if (isDurationRangeInvalid(minute, minuteUntil)) {
            return cms[128059];
        }
        return `${roundUpDuration(minuteUntil, cms)} ${cms[126842]}`;
    }

    const text = roundUpDuration(minute, cms);
    switch (type) {
        case DurationType.FROM:
            return `${text} ${cms[128057]}`;
        case DurationType.UNTIL:
            return `${text} ${cms[128058]}`;
        default:
            return `${text} ${cms[126842]}`;
    }
};

export default getDurationText;
